import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/Toaster';
import HomePage from './pages/HomePage';
import CreatePage from './pages/CreatePage';
import RecipePage from './pages/RecipePage';
import EmbedPage from './pages/EmbedPage';
import './styles.css';

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/recipe/:id" element={<RecipePage />} />
        <Route path="/embed" element={<EmbedPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

